import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.css']
})
export class AlertModalComponent implements OnInit {
  
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
    public dialog: MatDialog, 
    public matDialogRef: MatDialogRef<AlertModalComponent>,
  ) { }

  public isLoading: boolean;
  public hasButton: boolean = this.data.hasButton ?? true;
  ngOnInit(): void {
    this.isLoading = false;
  }

  close(){
    this.matDialogRef.close(); 
  }

}
